import { useState } from 'react';

export function useLoading() {
  const [loading, setLoading] = useState(false);

  const showLoader = () => {
    setLoading(true);
  };

  const hideLoader = () => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return {
    loader: loading,
    showLoader,
    hideLoader,
  };
}
